export function IAwardList() {
}

export interface IUser {
    id?: string;
    cgtnId?: string;
    cgtnName?: string;
    cgtnAvatar?: string;
    avatarBase64?: string;
    avatarFrame?: string;
    guestName?: string,
    countryCode?: string,
    country?: string,
    isLogin?: boolean,
    loginType?: LoginType; // 登录类型
    token?: string,
}

// 登录类型
export enum LoginType {
    GUEST = 1, // 游客登录
    CGTN = 2,  // CGTN登录
}

// 用户的游戏数据
export interface IUserGame {
    totalGamePlayed: number;
    dailyGameAverageGuessNum: number;
    dailyGameWinNum: number;
    dailyPlayed: number;
    aiChallengeBestStreak: number;
    dailyHighestRank: number,
    aiChallengeHighestRank: number,
    averageGuess: number;
}

// 国家区域选择
export interface ICountryRegion {
    id: number,
    countryCode?: string,
    countryName?: string,
}

// 徽章
export interface IMedal {
    id: number,
    medalName?: string,
    medalUrl?: string,
    grantType?: number,
    description?: string,
    remark?: string,
    hasGot?: boolean,
    hasEquipped?: boolean,
}

// 徽章类型
export enum MedalType {
    IMPORTANT_FESTIVAL = 1,         // 重要节日
    DAILY_SHARE = 2,                // 日常分享
    LEADERBOARD_RANKING = 3,        // 排行榜上榜
    CHALLENGE_MODE_ACHIEVEMENT = 4, // 挑战模式成就
    DAILY_MODE_ACHIEVEMENT = 5,     // 日常模式成就
}


// 头像
export interface IAvatarFrame {
    id: number,
    avatarFrameName?: string,
    avatarFrameUrl?: string,
    description?: string,
    remark?: string,
    hasGot?: boolean,
    hasEquipped?: boolean,
}

// 主题列表
export interface ITheme {
    id: number,
    themeName?: string,
    thumbnailUrl?: string,
    awardImgUrl?: string,
    description?: string,
    hasGot?: boolean,
    hasEquipped?: boolean,
}

// 主题配置
export interface IThemeSetting {
    gameTopBarBg: string,                       // 游戏界面-顶部Bar背景
    gameTopBackBtn: string,                     // 游戏界面-顶部返回按钮
    gameSettingBtn: string,                     // 游戏界面-顶部设置按钮
    gameQuestionBtn: string,                    // 游戏界面-顶部帮助按钮
    gameBg: string,                             // 游戏界面-游戏界面背景图
    gameSettlementCardBg: string,               // 游戏界面-游戏结算卡片背景图
    gameDescriptionTextColor: string,           // 游戏界面-描述文字颜色
    gameShareBtn: string,                       // 游戏界面-分享按钮
    gameNextLevelBtnBg: string,                 // 游戏界面-下一关按钮背景图
    gameAnswerLetterCardBg: string,             // 游戏界面-answer字母卡片背景
    gameClockIcon: string,                      // 游戏界面-时钟图标
    gamePlayChallengeBtnBg: string,             // 游戏界面-挑战按钮背景
    gameMouseWhiteIcon: string,                 // 游戏界面-挑战按钮上的鼠标图标

    dailyGameEndDialogBg: string,               // 每日游戏结束弹窗-背景图
    dailyGameEndDialogStatisticsCardBg: string, // 每日游戏结束弹窗-统计卡片背景
    dailyGameEndDialogAnswerCardBg: string,     // 每日游戏结束弹窗-答案卡片背景
    dailyGameEndDialogWordCardBg: string,       // 每日游戏结束弹窗-新闻文章卡片背景
    dailyGameEndDialogCloseIcon: string,        // 每日游戏结束弹窗-关闭按钮
    dailyGameEndDialogShareBtn: string,         // 每日游戏结束弹窗-分享按钮
    dailyGameEndDialogChallengeBtnBg: string,   // 每日游戏结束弹窗-挑战按钮背景

    aiGameFailDialogBg: string,                 // AI对战-失败弹窗背景
    aiGameFailDialogCardBg: string,             // AI对战-失败弹窗内容卡片背景
    aiGameFailDialogLeftAvatarBg: string,       // AI对战-失败弹窗左边头像背景
    aiGameFailDialogRightAvatarBg: string,      // AI对战-失败弹窗右边头像背景
    aiGameFailDialogChallengeBtnBg: string,     // AI对战-失败弹窗挑战按钮背景
    aiGameFailDialogShareBtn: string,           // AI对战-失败弹窗分享按钮
    aiGameFailDialogCloseBtn: string,           // AI对战-失败弹窗关闭按钮

    GameEndDialogLetterBg: string,              // 游戏结束弹窗-答案每个字母背景
}

// 每日游戏的正确单词
export interface IDailyGameCorrectWord {
    word?: string,
    wordId?: string,
    commonWord?: number,
    type?: string,
    importDate?: string,
    wordTitle?: string,
    wordPicture?: string,
    newLink?: string,
    popularSay?: string,
    hardLevel?: number,
    review3?: number,
    block?: number,
    wordAr?: number,
    playerTime?: string,
    aiTime?: number,
    publishDate?: string,
    hardTime?: number,
    wordNum?: number,
    wordIssue?: number
}

// 每日游戏的游戏状态
export interface IDailyWordStatus {
    date?: string,
    playTime?: number,
    totalWords: string[],
    hintUsed?: boolean,
    hintWord?: { letter: string, state: number },
    correctWord: string,
    gameStatus?: number,
    played?: number,
    winRate?: number,
    nextPlayTime?: number,
    wordIssue?: number,
}

// AI对战游戏的关卡单词
export interface IAIChallengeWord {
    word: string;
    ai_time: number;
    hard_time: number;
    hard_level: number;
}

// 每日游戏的排行榜接口返回的数据类型
export interface IDailyGameRankingData {
    dailyRanks: {
        userId?: string,
        cgtnName: string,
        cgtnAvatar: string,
        avatarFrame: string,
        playedTime: number,
    }[],
    wordIssue?: number,
    myRank?: string,
    playTime?: number,
}

// AI对战游戏的排行榜接口返回的数据类型
export interface IAIChallengeRankData {
    aiRankList: {
        userId: string
        cgtnName: string,
        cgtnAvatar: string,
        avatarFrame: string,
        level: number
    }[],
    myRank?: string,
    myLevel?: number,
}

// vs-player 对战房间信息
export interface IVSPlayerRoomInfo {
    id: string,
    correctWord: string,
    hardLevel: number,
    ownerUserId?: string,
    ownerCgtnName?: string,
    ownerCgtnAvatar?: string,
    ownerGuestName?: string,
    ownerGuessTimes?: number,
    ownerPlayTime?: number,
    ownerWin?: boolean,

    invitedUserId?: string,
    invitedCgtnName?: string,
    invitedGuestName?: string,
    invitedCgtnAvatar?: string,
    invitedGuessTimes?: number,
    invitedPlayTime?: number,
    invitedWin?: boolean,

    result?: number,
    completed?: boolean,
    avatarFrame?: string,
}

export interface IVSPlayerGameResult {
    roomId: string,
    guessTimes?: number,
    playTime?: number,
    totalGuessWord?: string,
    win?: boolean,
}

// UGC单词
export interface IUGCWord {
    id: string,
    userId: string,
    word: string,
    hint: string,
    likes: number,
    playCounts: number,
    successCounts: number,
    auditStatus: number, // 审核状态 0审核中1通过2被拒
}

// UGC游戏结果提交后返回的数据
export interface IUgcGameResponse {
    ugcGameLogId: string;
    hasWin: boolean;
    playTime: number;
    guessCount: number;
    solveRage: number;

    userCgtnName: string,
    userGuestName: string,
    userCgtnAvatar: string,

    wordId: string,
    correctWord: string,
    hintText: string,
    likes: number,
    playCount: number
}

// 获取登录奖励
export interface IAwardResult {
    medals: IMedal[],
    avatarFrames: IAvatarFrame[],
    themes: ITheme[],
}

// 获取对方的用户profile信息
export interface IUserInfo {
    userId: string;
    cgtnName: string;
    guestName: string;
    avatarUrl?: string;
    avatarFrameUrl?: string;
    country: string;
    userGame: IUserGame;
    medals: IMedal[];
}